/**
 * Dynamic Product Switcher V14 - Integrated Logic
 * 功能：多实例支持、Tab 居中滚动、切换时自动暂停所有视频
 */
const initDPSV14 = () => {
  const instances = document.querySelectorAll('.dps-main-instance');

  instances.forEach(instance => {
    const tabContainer = instance.querySelector('.js-tabs-container');
    const tabs = instance.querySelectorAll('.dps-tab-item');
    const contents = instance.querySelectorAll('.dps-content-box');
    const arrowLeft = instance.querySelector('.js-arrow-left');
    const arrowRight = instance.querySelector('.js-arrow-right');

    if (!tabContainer) return;

    // --- 核心功能：暂停当前实例下的所有视频 ---
    const pauseAllVideos = () => {
      // 暂停原生 <video> 标签
      instance.querySelectorAll('video').forEach(video => {
        video.pause();
      });

      // 暂停 YouTube Iframe (依赖 URL 中的 enablejsapi=1)
      instance.querySelectorAll('iframe.youtube-video').forEach(iframe => {
        try {
          iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
        } catch (e) {
          console.warn("Could not pause YouTube video:", e);
        }
      });
    };

    // --- 切换 Tab 逻辑 ---
    const switchTab = (tab) => {
      const targetId = tab.getAttribute('data-target');
      if (!targetId) return;

      // 1. 切换前先停止所有正在播放的视频
      pauseAllVideos();

      // 2. 更新 Tab 状态
      tabs.forEach(t => t.classList.remove('is-active'));
      tab.classList.add('is-active');

      // 3. 更新内容显隐
      contents.forEach(content => {
        content.classList.remove('is-active');
        if (content.id === targetId) {
          content.classList.add('is-active');
        }
      });

      // 4. 自动居中滚动 Tab 标签
      const scrollOffset = tab.offsetLeft - (tabContainer.offsetWidth / 2) + (tab.offsetWidth / 2);
      tabContainer.scrollTo({ left: scrollOffset, behavior: 'smooth' });
    };

    // 绑定点击事件
    tabs.forEach(tab => {
      tab.onclick = () => switchTab(tab);
    });

    // --- 箭头控制逻辑 ---
    const updateArrows = () => {
      const sl = tabContainer.scrollLeft;
      const max = tabContainer.scrollWidth - tabContainer.clientWidth;
      if (arrowLeft) {
        sl <= 5 ? arrowLeft.classList.add('is-disabled') : arrowLeft.classList.remove('is-disabled');
      }
      if (arrowRight) {
        sl >= max - 5 ? arrowRight.classList.add('is-disabled') : arrowRight.classList.remove('is-disabled');
      }
    };

    if (arrowLeft) {
      arrowLeft.onclick = (e) => {
        e.preventDefault();
        tabContainer.scrollBy({ left: -250, behavior: 'smooth' });
      };
    }

    if (arrowRight) {
      arrowRight.onclick = (e) => {
        e.preventDefault();
        tabContainer.scrollBy({ left: 250, behavior: 'smooth' });
      };
    }

    tabContainer.addEventListener('scroll', updateArrows, { passive: true });
    // 初始化箭头状态
    setTimeout(updateArrows, 300);
  });
};

// 初始化：支持页面初次加载
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initDPSV14);
} else {
  initDPSV14();
}

// 响应 Shopify 主题编辑器加载（当用户在后台修改设置时触发）
document.addEventListener('shopify:section:load', (e) => {
  if (e.target.classList.contains('dps-main-instance') || e.target.querySelector('.dps-main-instance')) {
    initDPSV14();
  }
});






/**
 * feature-grid-slider.liquid优化版：自由拖拽滚动（无吸附，低速更平滑）
 */
const initDragToScroll = () => {
  const sliders = document.querySelectorAll('.fg-track, .vc-track');

  sliders.forEach((slider) => {
    let isDown = false;
    let startX;
    let scrollLeft;

    // 优化：添加 { passive: true } 如果不需要 preventDefault
    // 但因为我们要阻止原生拖拽，所以 mousedown 保持默认，但可以优化移动端
    slider.addEventListener('mousedown', (e) => {
      isDown = true;
      slider.classList.add('grabbing');
      startX = e.clientX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
      slider.style.scrollBehavior = 'auto';
    });

    slider.addEventListener('mouseleave', () => {
      isDown = false;
      slider.classList.remove('grabbing');
    });

    slider.addEventListener('mouseup', () => {
      isDown = false;
      slider.classList.remove('grabbing');
    });

    slider.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault(); // 这里必须阻止默认行为，所以不能设为 passive
      const x = e.clientX - slider.offsetLeft;
      const walk = (x - startX) * 1.2; 
      slider.scrollLeft = scrollLeft - walk;
    });
  });
};

document.addEventListener('DOMContentLoaded', initDragToScroll);








/**
 * video-list.liquid - 深度隔离版
 */
(function () {
  const TARGET_WRAPPERS = [
    '.video-list__wrapper',
    '.vc-video-wrapper',
    '.dps-video-wrapper'
  ];

  // 1. 立即检查：如果页面上没有目标容器，直接退出，不执行任何操作
  const activeSections = document.querySelectorAll(TARGET_WRAPPERS.join(', '));
  if (activeSections.length === 0) return;

  // 内部存储，仅追踪属于这三个组件的播放器
  const managedHTMLVideos = [];
  const managedYTPlayers = [];

  // 内部暂停函数：只影响 managed 列表里的视频
  function pauseManagedMedia(except = null) {
    managedHTMLVideos.forEach(v => { if (v !== except) v.pause(); });
    managedYTPlayers.forEach(p => { 
      if (p !== except && p.pauseVideo) {
        try { p.pauseVideo(); } catch(e) {}
      }
    });
  }

  function setWrapperState(wrapper, state) {
    if (!wrapper) return;
    wrapper.classList.remove('is-playing', 'is-paused');
    wrapper.classList.add(state);
  }

  // --- 初始化 HTML5 视频 ---
  activeSections.forEach(section => {
    const videos = section.querySelectorAll('video');
    videos.forEach(video => {
      managedHTMLVideos.push(video);
      
      // 仅在 section 内部寻找或创建播放按钮
      const playBtn = section.querySelector('.video-list__play-btn');
      if (playBtn) {
        playBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          video.play();
        });
      }

      video.addEventListener('play', () => {
        pauseManagedMedia(video);
        setWrapperState(section, 'is-playing');
      });

      video.addEventListener('pause', () => setWrapperState(section, 'is-paused'));
      video.addEventListener('ended', () => setWrapperState(section, 'is-paused'));
    });
  });

  // --- 初始化 YouTube 视频 ---
  function initManagedYouTube() {
    activeSections.forEach(section => {
      // 关键：只抓取带有 .youtube-video 类名且在目标容器内的 iframe
      const iframes = section.querySelectorAll('.youtube-video');
      iframes.forEach(iframe => {
        // 如果 iframe 已经被初始化过，则跳过
        if (iframe.dataset.ytManaged === 'true') return;
        
        const player = new YT.Player(iframe, {
          events: {
            onStateChange: (event) => {
              if (event.data === YT.PlayerState.PLAYING) {
                pauseManagedMedia(event.target);
                setWrapperState(section, 'is-playing');
              } else if (event.data === YT.PlayerState.PAUSED || event.data === YT.PlayerState.ENDED) {
                setWrapperState(section, 'is-paused');
              }
            }
          }
        });

        iframe.dataset.ytManaged = 'true';
        managedYTPlayers.push(player);

        const playBtn = section.querySelector('.video-list__play-btn');
        if (playBtn) {
          playBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            if (player.playVideo) player.playVideo();
          });
        }
      });
    });
  }

  // --- 安全加载 YouTube API ---
  if (window.YT && window.YT.Player) {
    initManagedYouTube();
  } else {
    // 保护模式：不直接覆盖 window.onYouTubeIframeAPIReady
    // 而是将我们的逻辑“注入”到现有的钩子中
    const oldYTReady = window.onYouTubeIframeAPIReady;
    window.onYouTubeIframeAPIReady = function() {
      if (typeof oldYTReady === 'function') oldYTReady();
      initManagedYouTube();
    };

    // 只有在页面上有 .youtube-video 时才加载脚本
    if (document.querySelector('.youtube-video')) {
      const tag = document.createElement('script');
      tag.src = "https://www.youtube.com/iframe_api";
      const firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
  }
})();